var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canCreate)?_c('div',{staticClass:"float-right"},[_vm._v("\n   \n  "),_c('router-link',{staticClass:"btn btn-success",attrs:{"to":_vm.url}},[_vm._v(_vm._s(_vm.title))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ba48834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/CreateButton.vue
// module id = padR
// module chunks = 1